import {WebFormModel} from "capitalist-shared/src/core/model";
import axios from "axios";
import {CurrencyCode} from "@/models/core/currency";
import {RemoteRequestState} from "capitalist-shared/src/core/remote";

export class DepositUsdViaQiwiModel extends WebFormModel {

  initStatus = new RemoteRequestState()
  submitStatus = new RemoteRequestState()

  minimum = 3000
  maximum = 49000
  accounts = []

  values = {
    account: '',
    amount: '',
    pan: '',
    currency: CurrencyCode.RUR
  }


  loadModel() {
    this.initStatus.loadStart()
    return axios.post('/webapi/finance/usdcardsdeposit', {
      call: 'loadModel'
    }).then(result => {
      this.initStatus.loadEnd()
      this.accounts = result.data.model.options.accounts
      if (this.accounts.length > 0) {
        this.values.account = this.accounts[0].number
      }
      return result.data.model
    }).catch(err => {
      this.initStatus.loadError()
      throw err
    })
  }

  submit() {
    this.errors.clear()
    this.submitStatus.loadStart()
    return axios.post('/webapi/finance/usdcardsdeposit', {
      call: 'depositUsdUrl',
      m: this.values
    }).then(result => {
      this.submitStatus.loadEnd()
      return result.data
    }).catch(err => {
      this.checkAxiosError(err)
      this.submitStatus.loadError()
      throw err
    })
  }
}
